

export class EmployeeWeekOffUploadsDto {
    weekOffId: number;
    employeeId: number;
    employeeCode: string;
    employeeType: any;
    employeeCategory: string;
    weekOffDay: string;
    updatedAt: Date | any;
    updatedUser: string;
    createdAt: Date | any;
    createdUser: string;
    employeeName?:string;
  

    constructor(
        weekOffId: number,
        employeeId: number,
        employeeCode: string,
        employeeType: any,
        employeeCategory: string,
        weekOffDay: string,
        updatedAt: Date | any,
        updatedUser: string,
        createdAt: Date | any,
        createdUser: string,
        employeeName?:string

        

    ) {
        this.weekOffId = weekOffId;
        this.employeeId = employeeId;
        this.employeeCode = employeeCode;
        this.employeeType = employeeType;
        this.employeeCategory = employeeCategory;
        this.weekOffDay = weekOffDay;
        this.updatedAt = updatedAt;
        this.updatedUser = updatedUser;
        this.createdAt = createdAt;
        this.createdUser = createdUser;
        this.employeeName=employeeName
        

    }
}

export class EmployeeWeekOffUploadsModelDtoReq {
    data:EmployeeWeekOffUploadsDto[]
    user:string
constructor(
    data:EmployeeWeekOffUploadsDto[],
    user:string
){
this.data = data
this.user = user
}}

